// extracted by mini-css-extract-plugin
export default {"boxList":"ContactBox-module--boxList--drjmS","box":"ContactBox-module--box--GxwJQ"};